// extracted by mini-css-extract-plugin
module.exports = {"empty":"style_empty__SLmJa","empty__image":"style_empty__image__tstcC","empty__title":"style_empty__title__Kh2Lp","empty__description":"style_empty__description__O3xP_"};